import { useSelector } from "react-redux";
import { DemoUsageType } from "shared/enums/DemoUsageTypeEnum";
import { RootState } from "store/store";
import { H2 } from "../Headings";
import DownloadExcelExample from "./DownloadExcelExample";
import DownloadPowerBIExample from "./DownloadPowerBIExample";
import SignInInstructionToDownloadExample from "./SignInInstructionToDownloadExample";

interface Props {
  logDownload: (demoId: string, usageType: DemoUsageType) => void;
}

export default function DownloadExample(props: Props) {
  const isAuthenticated = useSelector(
    (state: RootState) => state.authData.isAuthenticated
  );

  return (
    <>
      <div>
        <H2> Downloads </H2>
      </div>
      <div>
        {isAuthenticated ? (
          <div className="flex space-x-4">
            <DownloadExcelExample logDownload={props.logDownload} />
            <DownloadPowerBIExample logDownload={props.logDownload} />
          </div>
        ) : (
          <SignInInstructionToDownloadExample />
        )}
      </div>
    </>
  );
}
